/**
 * Return the basket items/answers.
 */

import type { RootState } from '/business/shared/state/store';
import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';
import type { EmissionTypeOption } from '/business/shared/state/reducers/emissionTypes';

export default (state: RootState): EmissionTypeOption[] => state.emissionTypes?.data?.waste || EMPTY_ARRAY;
